'use client'
// todo: 实现有问题，待优化
import { createContext, useState, ReactNode, Fragment, useContext, useEffect, memo } from 'react'
import EventEmitter from 'events'

const loginEmitter = new EventEmitter()

export const dispatchLogout = () => {
  loginEmitter.emit('logout')
}

export enum LoginStatus {
  CHECKING = 'CHECKING',
  LOGGED_IN = 'LOGGED_IN',
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
}
type TContext<ILoginInfo> = {
  loginData?: ILoginInfo
  afterLogin: () => Promise<ILoginInfo>
  dispatchLogin: (
    data: ILoginInfo & {
      disableRedirect?: boolean
    }
  ) => void
  logout: () => void
  register: () => void
  login: (loginOptions?: TAuthOptions) => void
  thirdPartyLoginComponents?: Record<string, ReactNode>
}

const AuthContext = createContext<TContext<any> | null>(null)

export const useAuthenticate = () => {
  const authenticate: TContext<any> = useContext(AuthContext)!
  if (!authenticate) {
    throw new Error('useAuthenticate must be used within a AuthenticateProvider')
  }
  return authenticate
}
export type TAuthOptions = {
  disableRedirect?: boolean
  disableICCode?: boolean
}

type TProps<TLoginData, TLoginInfo> = {
  children: ReactNode
  onLogin?: (data: TLoginInfo) => Promise<void>
  handleRegister?: () => void
  handleLogin?: (loginOptions?: TAuthOptions) => void
  onLogout?: () => Promise<void>
  updateLoginData: () => TLoginData
  getThirdPartyLoginComponents: (updateLoginData) => Record<string, ReactNode>
}
export const AuthProvider = memo(<TLoginData,>(props: TProps<TLoginData, any>): any => {
  // 通过用户数据来判断登录状态
  // undefined 正在检查
  // null 未登录
  // 有数据 已登录
  const [loginData, setLoginData] = useState<TLoginData | null | undefined>()

  const updateLoginData = () => {
    const data = props.updateLoginData()
    if (!data) {
      setLoginData(null)
      return
    }

    setLoginData(data)
  }
  useEffect(updateLoginData, [props, props.updateLoginData])

  useEffect(() => {
    const onLogout = async () => {
      await props.onLogout?.()
      setLoginData(null)
    }
    loginEmitter.on('logout', onLogout)
    return () => {
      loginEmitter.off('logout', onLogout)
    }
  }, [])

  const context: TContext<any> = {
    loginData,
    dispatchLogin: (data: any) => {
      props.onLogin?.(data).then(updateLoginData)
    },
    logout() {
      props.onLogout?.().then(updateLoginData)
    },
    login: (loginOptions?: TAuthOptions) => {
      props.handleLogin?.(loginOptions)
    },
    register: () => {
      props.handleRegister?.()
    },
    thirdPartyLoginComponents: props.getThirdPartyLoginComponents?.(updateLoginData),
    afterLogin: async () => {
      // if (loginStatus === LoginStatus.LOGGED_IN) {
      //   return loginData;
      // }
      // const data = await props.handleLogin?.()
      // setLoginData(data)
      // setLoginStatus(LoginStatus.LOGGED_IN)
      // return data
    },
  }

  return <AuthContext.Provider value={context}>{props.children}</AuthContext.Provider>
})

AuthProvider.displayName = 'AuthProvider'

type TConfirmParams = {
  loginData: any
  logout: () => void
}
type TDenyParams = {
  login: () => void
  register: () => void
  thirdPartyLoginComponents: Record<string, ReactNode>
}

type TAuthenticationProps = {
  allow?: (params: TConfirmParams) => JSX.Element
  deny?: (params: TDenyParams) => JSX.Element
  notAllow?: (params: TDenyParams) => JSX.Element
  checking?: (params: TContext<any>) => JSX.Element
  children?: (params: TContext<any>) => JSX.Element
}

export const Authentication = (props: TAuthenticationProps) => {
  const authenticate = useContext(AuthContext)!
  const { loginData, logout, login, register, thirdPartyLoginComponents } = authenticate!

  let loginStatus
  if (loginData === undefined) {
    loginStatus = LoginStatus.CHECKING
  } else if (loginData === null) {
    loginStatus = LoginStatus.NOT_LOGGED_IN
  } else {
    loginStatus = LoginStatus.LOGGED_IN
  }
  return [
    <Fragment key="renderProps">
      {loginStatus === LoginStatus.CHECKING && props.checking?.(authenticate)}
      {loginData &&
        loginStatus === LoginStatus.LOGGED_IN &&
        props.allow?.({
          loginData,
          logout,
        })}
      {[LoginStatus.CHECKING, LoginStatus.NOT_LOGGED_IN].includes(loginStatus) &&
        props.notAllow?.({
          login,
          register,
          thirdPartyLoginComponents,
        })}
      {loginStatus === LoginStatus.NOT_LOGGED_IN &&
        props.deny?.({
          login,
          register,
          thirdPartyLoginComponents,
        })}
    </Fragment>,
    <Fragment key="renderChildren">{props.children?.(authenticate)}</Fragment>,
  ]
}
